<template>
    <form-wrapper>
        <div class="email-collector">
            <form-repeater
                :repeats="repeats"
                :add="$t(addLinkLabel)"
                :hint="''"
                :remove="''"
                :isDisabled="false"
                @add="addRepeat()"
                @remove="removeRepeat($event)"
            >
                <template #default="{ data, index }">
                    <form-row class="email-collector--name-row">
                        <form-cell width="half">
                            <text-field
                                :label="$t('elements.network.email_collector.first_name')"
                                :placeholder="$t('elements.network.email_collector.first_name')"
                                :isRequired="false"
                                :formData="data"
                                :valuePath="valuePathField(index, 'firstName')"
                                :formRepeater="true"
                                @change="changeRepeat(index, $event)"
                            ></text-field>
                        </form-cell>

                        <form-cell width="half">
                            <text-field
                                :label="$t('elements.network.email_collector.last_name')"
                                :placeholder="$t('elements.network.email_collector.last_name')"
                                :isRequired="false"
                                :formData="data"
                                :valuePath="valuePathField(index, 'lastName')"
                                :formRepeater="true"
                                @change="changeRepeat(index, $event)"
                            ></text-field>
                        </form-cell>
                    </form-row>
                    <form-row
                        v-if="isInviteToPractice && $auth.getPractice().practiceType === PracticeTypeEnum.PHYSICIAN"
                        class="email-collector--role-row"
                    >
                        <form-cell>
                            <select-field
                                :label="$t('elements.network.email_collector.choose_role')"
                                :placeholder="$t('elements.network.email_collector.choose_role')"
                                :options="practiceRoles"
                                :isRequired="true"
                                :formData="data"
                                :valuePath="valuePathField(index, 'userRoleId')"
                                :formRepeater="true"
                                @change="changeUserRoleRepeater(index, $event)"
                            ></select-field>
                        </form-cell>
                    </form-row>
                    <form-row v-if="showCanActivateAnotherUserField(index)" class="email-collector--privilege-row">
                        <form-cell>
                            <switch-input
                                :label="$t('elements.network.email_collector.can_activate_another_user')"
                                :isLabelOnLeft="true"
                                :value="repeats[index].canActivateAnotherUser"
                                spacing="space-between"
                                @change="changeCanActivateAnotherUser(index, $event)"
                            ></switch-input>
                        </form-cell>
                    </form-row>
                    <form-row v-if="showDesignationAndSpecialityFields(index)">
                        <form-cell width="third">
                            <select-field
                                :label="$t('forms.auth.register.fields.title.label')"
                                :placeholder="$t('forms.auth.register.fields.title.placeholder')"
                                :options="designationOptions(index)"
                                :isRequired="true"
                                :formData="data"
                                :valuePath="valuePathField(index, 'designation')"
                                :formRepeater="true"
                                @change="changeRepeat(index, $event)"
                            ></select-field>
                        </form-cell>

                        <form-cell>
                            <multi-select-field
                                :label="$t('forms.auth.register.fields.specialty.label')"
                                :placeholder="$t('forms.auth.register.fields.specialty.placeholder')"
                                :isRequired="true"
                                :formData="data"
                                :options="specialities"
                                :expandableOptions="true"
                                :oneOptionSelected="true"
                                :grayColor="true"
                                :valuePath="valuePathField(index, 'specialities')"
                                :formRepeater="true"
                                @change="changeRepeat(index, $event)"
                            ></multi-select-field>
                        </form-cell>
                    </form-row>
                    <form-row>
                        <form-cell>
                            <phone-field
                                v-if="displayPhoneField"
                                :label="label + ' ' + (index + 1) + ' ' + $t(inviteByLabel)"
                                :placeholder="$t('common.phone_number.placeholder')"
                                :isRequired="false"
                                :formData="data"
                                :error="data.error"
                                :valuePath="valuePathField(index, 'email')"
                                :formRepeater="true"
                                @change="changeRepeat(index, $event)"
                            ></phone-field>
                            <text-field
                                v-if="displayEmailField"
                                :label="label + ' ' + (index + 1) + ' ' + $t(inviteByLabel)"
                                :placeholder="$t(inviteByPlaceholder)"
                                :isRequired="false"
                                :formData="data"
                                :title="$t(inviteByFieldTitle)"
                                :error="data.error"
                                type="email"
                                :valuePath="valuePathField(index, 'email')"
                                :formRepeater="true"
                                @change="changeRepeat(index, $event)"
                            ></text-field>
                        </form-cell>
                    </form-row>
                </template>
            </form-repeater>
            <form-row>
                <form-cell>
                    <common-button
                        :label="buttonLabel"
                        type="primary"
                        :isSubmittable="true"
                        :isProcessing="isLoading"
                        :isDisabled="isDisabled()"
                        @click="collect"
                    ></common-button>
                </form-cell>
            </form-row>
        </div>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import FormRepeaterMixin from 'mixins/FormRepeaterMixin'
    import FormChangeableMixin from 'mixins/FormChangeableMixin'
    import InviteByEnum from '@/enums/InviteByEnum'
    import SpecialitiesAPI from 'api/SpecialitiesAPI'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'
    import UserRolesEnum from '@/enums/UserRolesEnum'
    import UserDesignationEnum from '@/enums/UserDesignationEnum'

    export default {
        mixins: [FormMixin, FormChangeableMixin, FormRepeaterMixin],

        props: {
            label: { type: String, required: true },
            placeholder: { type: String, required: true },
            buttonLabel: { type: String, required: true },
            initialNumOfFields: { type: Number, default: 3 },
            inviteBy: { type: String, required: false, default: InviteByEnum.INVITE_BY_EMAIL },
            isLoading: { type: Boolean, default: false },
            isInviteToPractice: { type: Boolean, default: false },
        },
        data() {
            return {
                phoneCountryCode: '1',
                practiceRole: null,
                practiceRoles: [],
                specialities: [],
                PracticeTypeEnum: PracticeTypeEnum,
                UserRolesEnum: UserRolesEnum,
                UserDesignationEnum: UserDesignationEnum,
            }
        },
        computed: {
            inviteByLabel() {
                return this.inviteBy === InviteByEnum.INVITE_BY_EMAIL
                    ? 'elements.network.email_collector.email'
                    : 'elements.network.email_collector.phone'
            },

            inviteByFieldTitle() {
                return this.inviteBy === InviteByEnum.INVITE_BY_EMAIL
                    ? 'elements.network.email_collector.input_field_title'
                    : 'elements.network.email_collector.input_field_phone_title'
            },

            inviteByPlaceholder() {
                return this.inviteBy === InviteByEnum.INVITE_BY_EMAIL
                    ? this.placeholder
                    : 'elements.network.email_collector.phone_placeholder'
            },
            addLinkLabel() {
                return this.inviteBy === InviteByEnum.INVITE_BY_EMAIL
                    ? 'elements.network.email_collector.add_email_link'
                    : 'elements.network.email_collector.add_phone_link'
            },
            displayPhoneField() {
                return this.inviteBy === InviteByEnum.INVITE_BY_PHONE
            },
            displayEmailField() {
                return this.inviteBy === InviteByEnum.INVITE_BY_EMAIL
            },
        },

        methods: {
            collect() {
                let regex = new RegExp(
                    "^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$",
                )
                let errorMessage = this.$t('elements.network.email_collector.invalid_email_address')
                if (this.inviteBy === InviteByEnum.INVITE_BY_PHONE) {
                    //eslint-disable-next-line
                    regex = new RegExp('^[0-9]{10}$')
                    errorMessage = this.$t('elements.network.email_collector.invalid_phone_number')
                }

                if (this.validate(regex, errorMessage)) {
                    const invites = this.formData.emailFields
                        .filter((field) => field.email)
                        .map((field) => {
                            const invite = { ...field }
                            delete invite.error

                            if (this.inviteBy === InviteByEnum.INVITE_BY_EMAIL) {
                                invite.inviteBy = InviteByEnum.INVITE_BY_EMAIL
                            } else {
                                invite.phone = this.phoneCountryCode + invite.email
                                invite.inviteBy = InviteByEnum.INVITE_BY_PHONE
                                delete invite.email
                            }

                            if (invite.userRoleId === UserRolesEnum.NURSE_PRACTITIONER.ID) {
                                invite.canActivateAnotherUser = !!invite.canActivateAnotherUser
                            } else {
                                delete invite.canActivateAnotherUser
                            }

                            return invite
                        })
                    this.$emit('emails-collected', invites)
                }
            },
            validate(regex, errorMessage) {
                let allValid = true
                let hasEntries = false

                this.formData.emailFields.forEach((field) => (field.error = ''))

                for (let i = 0; i < this.formData.emailFields.length; ++i) {
                    let field = this.formData.emailFields[i]
                    if (field.email) {
                        hasEntries = true
                        if (!regex.test(field.email)) {
                            field.error = errorMessage
                            allValid = false
                        }
                    }
                }
                return hasEntries && allValid
            },
            createRepeat() {
                return {
                    email: '',
                    error: '',
                    userRoleId: null,
                    firstName: '',
                    lastName: '',
                    designation: null,
                    specialities: [],
                    canActivateAnotherUser: false,
                }
            },
            isDisabled() {
                return (
                    !this.formData.emailFields.some((field) => field.email.length > 0) ||
                    (!this.formData.emailFields.some((field) => field.userRoleId) &&
                        this.isInviteToPractice &&
                        this.$auth.getPractice().practiceType === PracticeTypeEnum.PHYSICIAN)
                )
            },
            async getSpecialitiesData() {
                this.specialities = await SpecialitiesAPI.getListMultiselect()
            },
            showDesignationAndSpecialityFields(index) {
                return (
                    this.repeats[index].userRoleId === UserRolesEnum.PHYSICIAN.ID ||
                    this.repeats[index].userRoleId === UserRolesEnum.NURSE_PRACTITIONER.ID
                )
            },
            showCanActivateAnotherUserField(index) {
                return this.isInviteToPractice && this.repeats[index].userRoleId === UserRolesEnum.NURSE_PRACTITIONER.ID
            },
            changeCanActivateAnotherUser(index, value) {
                this.$set(this.repeats[index], 'canActivateAnotherUser', value)
                this.change(this.repeats)
            },
            changeUserRoleRepeater(index, { path, value }) {
                const parts = path.split('.')
                this.$set(this.repeats[index], parts[parts.length - 1], value)
                this.$set(this.repeats[index], 'designation', null)
                this.$set(this.repeats[index], 'specialities', [])
                this.$set(this.repeats[index], 'canActivateAnotherUser', false)
                this.change(this.repeats)
            },
            designationOptions(index) {
                let designations = Object.values(UserDesignationEnum).map((designation) => ({
                    value: designation,
                    label: designation,
                }))
                const userRoleId = this.repeats[index]?.userRoleId
                if (userRoleId === UserRolesEnum.NURSE_PRACTITIONER.ID) {
                    return designations.filter(
                        (item) => item.value === UserDesignationEnum.PA || item.value === UserDesignationEnum.NP,
                    )
                }

                return designations.filter(
                    (item) => item.value !== UserDesignationEnum.PA && item.value !== UserDesignationEnum.NP,
                )
            },
        },

        async mounted() {
            if (this.isInviteToPractice && this.$auth.getPractice().practiceType === PracticeTypeEnum.PHYSICIAN) {
                this.practiceRoles = Object.values(UserRolesEnum)
                    .filter(
                        (role) => role.ID !== UserRolesEnum.ADMINISTRATOR.ID && role.ID !== UserRolesEnum.TEMPORARY_PHYSICIAN.ID,
                    )
                    .map((role) => ({
                        value: role.ID,
                        label: role.NAME,
                    }))
                await this.getSpecialitiesData()
            }
        },
    }
</script>

<style scoped>
    .email-collector {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .email-collector .email-collector--name-row {
        margin-bottom: 10px;
    }
    .email-collector .email-collector--privilege-row {
        margin-top: 10px;
        width: 100%;
    }
    .email-collector > .form-repeater {
        height: 380px;
        overflow-y: auto;
        padding-left: 20px;
        padding-right: 20px;
    }

    .email-collector .add-email-link {
        font-weight: 500;
        color: #13b3e3;
        cursor: pointer;
    }
    .email-collector >>> .form-repeater .form-repeater__group:not(:first-child) {
        border-top: none;
        margin-top: 0px;
    }
    .email-collector >>> .form-repeater .form-repeater__group .form-row:not(:first-child) {
        margin-top: 10px;
    }
</style>
